module.exports = __webpack_public_path__ + "static/media/thumnail_achamba_ka_saathi.69c46c90.svg";